var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixedWidth"},[_c('h2',[_vm._v("Sorry, we couldn't find that page.")]),_c('h3',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("To the home page!")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }